module.exports = __webpack_public_path__ + "static/media/escudo.0f504ad0.png";


//////////////////
// WEBPACK FOOTER
// ./public/imagenes/escudo.png
// module id = 112
// module chunks = 0